import { useCallback, useRef, useState } from 'react';

const useIsHovered = <T extends HTMLElement>() => {
  const [isHovered, setIsHovered] = useState(false);

  const elementRef = useRef<T | null>(null);

  const onMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  const bindRef = useCallback(
    (node: T | null) => {
      if (elementRef.current) {
        elementRef.current.removeEventListener('mouseenter', onMouseEnter);
        elementRef.current.removeEventListener('mouseleave', onMouseLeave);
      }

      elementRef.current = node;

      if (!node) return;

      node.addEventListener('mouseenter', onMouseEnter);
      node.addEventListener('mouseleave', onMouseLeave);
    },
    [onMouseEnter, onMouseLeave],
  );

  return {
    bindRef,
    elementRef,
    isHovered,
  };
};

export default useIsHovered;
